import { call, put } from "redux-saga/effects";
import CustomersActions from "./customers-actions"
import * as api from "../../services/api"
import { parsePaginatedListResponse } from "../../utils/paginationUtils"

const normalizeListResponse = (data) => {
    if (!data) {
        return [];
    }
    if (Array.isArray(data)) {
        return data;
    }
    if (Array.isArray(data.content)) {
        return data.content;
    }
    return [];
}

export function* getCustomers(action) {
    const { options } = action
    const response = yield call(api.getCustomers, options)
    //success?
    if (response.ok) {
        yield put(CustomersActions.customersSuccess(response.data));
    } else {
        yield put(CustomersActions.customersFailure(response.data))
    }
}

export function* getCustomersCount() {
    const response = yield call(api.getCustomersCount)
    //success?
    if (response.ok) {
        yield put(CustomersActions.customersCountSuccess(response.data));
    } else {
        yield put(CustomersActions.customersCountFailure(response.data))
    }
}

export function* getCustomerImportsList(action) {
    const { businessId, options } = action
    const response = yield call(api.getCustomerImports, businessId, options)
    //success?
    if (response.ok) {
        yield put(CustomersActions.customerImportsSuccess(response.data));
    } else {
        yield put(CustomersActions.customerImportsFailure(response.data))
    }
}

export function* getCustomerImport(action) {
    const { importId } = action
    const response = yield call(api.getCustomerImport, importId)
    if (response.ok) {
        yield put(CustomersActions.customerImportSuccess(response.data));
    } else {
        yield put(CustomersActions.customerImportFailure(response.data))
    }
}

export function* uploadDocument(action) {
    const { businessId, audienceId, name, file } = action
    const response = yield call(api.uploadCustomerImports, businessId, audienceId, name, file)
    if (response.ok) {
        yield put(CustomersActions.uploadSuccess(response.data));
    } else {
        yield put(CustomersActions.uploadFailure(response.data))
    }
}

export function* applyCustomerImport(action) {
    const { id, batchNo, mode } = action
    const response = yield call(api.applyImport, id, batchNo, mode)
    if (response.ok) {
        yield put(CustomersActions.applyUploadSuccess(response.data));
    } else {
        yield put(CustomersActions.applyUploadFailure(response.data))
    }
}

export function* getListOfCustomerEntries(action) {
    const { importId } = action
    const response = yield call(api.getEntriesList, importId)
    if (response.ok) {
        yield put(CustomersActions.entriesSuccess(response.data));
    } else {
        yield put(CustomersActions.entriesFailure(response.data))
    }
}

export function* getAudienceMembers(action) {
    const { audienceId, options } = action
    const response = yield call(api.getAudienceMembers, audienceId, options)
    if (response.ok) {
        yield put(CustomersActions.audienceMembersSuccess(parsePaginatedListResponse(response, options)));
    } else {
        yield put(CustomersActions.audienceMembersFailure(response.data))
    }
}

export function* getAudienceCandidateSegments(action) {
    const { audienceId } = action
    const response = yield call(api.getAudienceCandidateSegments, audienceId)
    if (response.ok) {
        yield put(CustomersActions.audienceCandidateSegmentsSuccess(normalizeListResponse(response.data)));
    } else {
        yield put(CustomersActions.audienceCandidateSegmentsFailure(response.data))
    }
}

export function* getAudienceCandidateTags(action) {
    const { audienceId } = action
    const response = yield call(api.getAudienceCandidateTags, audienceId)
    if (response.ok) {
        yield put(CustomersActions.audienceCandidateTagsSuccess(normalizeListResponse(response.data)));
    } else {
        yield put(CustomersActions.audienceCandidateTagsFailure(response.data))
    }
}

export function* saveAudienceCandidateMetadata(action) {
    const { audienceId, metadata } = action
    const response = yield call(api.saveAudienceCandidateMetadata, audienceId, metadata)
    if (response.ok) {
        yield put(CustomersActions.saveAudienceCandidateMetadataSuccess(response.data));
    } else {
        yield put(CustomersActions.saveAudienceCandidateMetadataFailure(response.data))
    }
}

export function* applyAudienceCandidates(action) {
    const { audienceId } = action
    const response = yield call(api.applyAudienceCandidates, audienceId)
    if (response.ok) {
        yield put(CustomersActions.applyAudienceCandidatesSuccess(response.data));
    } else {
        yield put(CustomersActions.applyAudienceCandidatesFailure(response.data))
    }
}

export function* getAudienceBulkInvitations(action) {
    const { audienceId } = action
    const response = yield call(api.getAudienceBulkInvitations, audienceId)
    if (response.ok) {
        yield put(CustomersActions.audienceBulkInvitationsSuccess(normalizeListResponse(response.data)));
    } else {
        yield put(CustomersActions.audienceBulkInvitationsFailure(response.data))
    }
}

export function* getAudienceBatches(action) {
    const { audienceId } = action
    const response = yield call(api.getAudienceBatches, audienceId)
    if (response.ok) {
        yield put(CustomersActions.audienceBatchesSuccess(normalizeListResponse(response.data)));
    } else {
        yield put(CustomersActions.audienceBatchesFailure(response.data))
    }
}

export function* downloadAudienceCsv(action) {
    const { audienceId } = action
    const response = yield call(api.downloadAudienceMembers, audienceId);
    if (response.ok) {
        const blob = new Blob([response.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `audience-${audienceId}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        yield put(CustomersActions.downloadAudienceCsvSuccess(response.data));
    } else {
        yield put(CustomersActions.downloadAudienceCsvFailure(response.data))
    }
}

export function* submitCustomerEnrichment(action) {
    const { businessId, file } = action
    const response = yield call(api.submitCustomerEnrichment, businessId, file)
    if (response.ok) {
        yield put(CustomersActions.submitCustomerEnrichmentSuccess(response.data));
    } else {
        yield put(CustomersActions.submitCustomerEnrichmentFailure(response.data))
    }
}

export function* getCustomerEnrichments(action) {
    const { businessId, options } = action
    const response = yield call(api.getCustomerEnrichments, businessId, options)
    if (response.ok) {
        yield put(CustomersActions.customerEnrichmentsSuccess(parsePaginatedListResponse(response, options)));
    } else {
        yield put(CustomersActions.customerEnrichmentsFailure(response.data))
    }
}

export function* getCustomerEnrichmentStatus(action) {
    const { businessId, requestId } = action
    const response = yield call(api.getCustomerEnrichmentStatus, businessId, requestId)
    if (response.ok) {
        yield put(CustomersActions.customerEnrichmentStatusSuccess(response.data));
    } else {
        yield put(CustomersActions.customerEnrichmentStatusFailure(response.data))
    }
}

export function* getCustomerEnrichmentItems(action) {
    const { businessId, requestId, options } = action
    const response = yield call(api.getCustomerEnrichmentItems, businessId, requestId, options)
    if (response.ok) {
        yield put(CustomersActions.customerEnrichmentItemsSuccess(
            parsePaginatedListResponse(response, options),
            requestId
        ));
    } else {
        yield put(CustomersActions.customerEnrichmentItemsFailure(response.data))
    }
}

export function* downloadSampleCsv() {
    // make the call to the api
    const response = yield call(api.businessCustomerCsvDownload);
    // success?
    if (response.ok) {
        // Create a Blob from the response data
        const blob = new Blob([response.data], { type: 'text/csv' });

        // Create a URL for the Blob
        const url = window.URL.createObjectURL(blob);

        // Create a link element
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'customer_import_template.csv'); // Set the file name

        // Append the link to the body and click it to trigger download
        document.body.appendChild(link);
        link.click();
        yield put(CustomersActions.downloadCsvSuccess(response.data));
    } else {
        yield put(CustomersActions.downloadCsvFailure(response.data))
    }
}

export function* sendBulkInvite(action) {
    const { businessId, inviteData } = action
    const response = yield call(api.sendBulkInvite, businessId, inviteData)
    if (response.ok) {
        yield put(CustomersActions.bulkPlanInviteSuccess(response.data));
    } else {
        yield put(CustomersActions.bulkPlanInviteFailure(response.data))
    }
}

export function* getBusinessCustomerRecord(action) {
    const { businessCustomerId } = action

    const response = yield call(api.getBusinessCustomerRecord, businessCustomerId)

    // success?
    if (response.ok) {
        yield put(CustomersActions.businessCustomerRecordSuccess(response.data))
    } else {
        yield put(CustomersActions.businessCustomerRecordFailure(response.data))
    }
}

export function* linkBusinessCustomer(action) {
    const { secondaryBusinessCustomerId, primaryBusinessCustomerId, reason } = action
    const response = yield call(
        api.linkBusinessCustomerToPrimary,
        secondaryBusinessCustomerId,
        primaryBusinessCustomerId,
        reason
    )
    if (response.ok) {
        yield put(CustomersActions.linkBusinessCustomerSuccess(response.data))
    } else {
        yield put(CustomersActions.linkBusinessCustomerFailure(response.data))
    }
}

export function* unlinkBusinessCustomer(action) {
    const { secondaryBusinessCustomerId } = action
    const response = yield call(api.unlinkBusinessCustomerFromPrimary, secondaryBusinessCustomerId)
    if (response.ok) {
        yield put(CustomersActions.unlinkBusinessCustomerSuccess(response.data))
    } else {
        yield put(CustomersActions.unlinkBusinessCustomerFailure(response.data))
    }
}

export function* getCanonicalBusinessCustomer(action) {
    const { secondaryBusinessCustomerId } = action
    const response = yield call(api.getCanonicalBusinessCustomer, secondaryBusinessCustomerId)
    if (response.ok) {
        yield put(CustomersActions.canonicalBusinessCustomerSuccess(response.data))
    } else {
        yield put(CustomersActions.canonicalBusinessCustomerFailure(response.data))
    }
}

export function* getBusinessCustomerSummary(action) {
    const { businessCustomerId } = action
    const response = yield call(api.getBusinessCustomerSummary, businessCustomerId)
    if (response.ok) {
        yield put(CustomersActions.businessCustomerSummarySuccess(response.data))
    } else {
        yield put(CustomersActions.businessCustomerSummaryFailure(response.data))
    }
}

export function* getSecondaryBusinessCustomers(action) {
    const { bcId, options } = action
    const response = yield call(api.getSecondaryBusinessCustomers, bcId, options)
    if (response.ok) {
        yield put(CustomersActions.secondaryBusinessCustomersSuccess(response.data))
    } else {
        yield put(CustomersActions.secondaryBusinessCustomersFailure(response.data))
    }
}

export function* getSecondaryBusinessCustomersCount(action) {
    const { bcId } = action
    const response = yield call(api.getSecondaryBusinessCustomersCount, bcId)
    if (response.ok) {
        yield put(CustomersActions.secondaryBusinessCustomersCountSuccess(response.data))
    } else {
        yield put(CustomersActions.secondaryBusinessCustomersCountFailure(response.data))
    }
}

export function* createBusinessCustomer(action) {
    const { businessId, customerDto } = action
    const response = yield call(api.createBusinessCustomer, businessId, customerDto)
    if (response.ok) {
        yield put(CustomersActions.createBusinessCustomerSuccess(response.data))
    } else {
        yield put(CustomersActions.createBusinessCustomerFailure(response.data))
    }
}

export function* updateBusinessCustomerSimple(action) {
    const { id, customerDto } = action
    const response = yield call(api.updateBusinessCustomerSimple, id, customerDto)
    if (response.ok) {
        yield put(CustomersActions.updateBusinessCustomerSimpleSuccess(response.data))
    } else {
        yield put(CustomersActions.updateBusinessCustomerSimpleFailure(response.data))
    }
}

export function* createAudience(action) {
    const { audienceDto } = action
    const response = yield call(api.createAudience, audienceDto)
    if (response.ok) {
        yield put(CustomersActions.createAudienceSuccess(response.data))
    } else {
        yield put(CustomersActions.createAudienceFailure(response.data))
    }
}